module.exports = __webpack_public_path__ + "static/media/lightTheme.41adee85.jpg";